import "./SubscriptionPreferencesEditForm.scss";
import "bootstrap/dist/css/bootstrap.min.css";

import React from "react";
import { SubscriptionPreferencesHrComponent } from "../_shared/hr/SubscriptionPreferencesHrComponent";
import { useBemBlock } from "@common/utils/bemContext/bemContextHook";
import { cl } from "@ngd-web/lv-utils/ui/classNames";
import { GeneralConsentsComponent } from "../generalConsents/GeneralConsentsComponent";
import { SubscriptionsTableElement } from "../subscriptionsTable/SubscriptionsTableElement";
import { UmSpEditFormButtonsElement } from "../editFormButtons/UmSpEditFormButtonsElement";
import { GlobalConsentsErrorElement } from "../subscriptionsTableErrors/GlobalConsentsErrorElement";
import { umSpPageHasSubscriptionsTableSelector } from "../_shared/selectors";
import { useSelector } from "react-redux";

export function SubscriptionPreferencesEditFormComponent({ className, texts }) {
    const [bl, el] = useBemBlock("usmSubscriptionPreferencesEditForm");
    const hasSubscriptionsTable = useSelector(
        umSpPageHasSubscriptionsTableSelector
    );

    return (
        <div className={cl(className, bl())}>
            <div className={el("general-consents-title")}>
                {texts.generalConsentsTitle}
            </div>

            <GeneralConsentsComponent className={el("general-consents")} />

            <GlobalConsentsErrorElement
                className={el("general-consents-error")}
            />

            <div className={el("warning")}>{texts.notice}</div>

            {hasSubscriptionsTable && <SubscriptionPreferencesHrComponent />}

            {hasSubscriptionsTable && <SubscriptionsTableElement el={el} />}

            <UmSpEditFormButtonsElement el={el} />
        </div>
    );
}
